module.exports = __webpack_public_path__ + "media/bgm_106.4791ec8a.m4a";